import { useState } from 'react';
import { Button, Card, Col, Collapse, Form, Row } from 'react-bootstrap';
import { useQueryClient } from 'react-query';
import DatePicker from '../../components/forms/formDatePicker';
import FormInput from "../../components/forms/formInput";

const ExpensesFilter = ({ isFiltering, onFilter }) => {

    const [isShow, setIsShow] = useState(false)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [category, setCategory] = useState('')
    const [paymentMethod, setPaymentMethod] = useState('')
    const queryClient = useQueryClient()

    const handleFilter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onFilter([
            dateFrom ? new Date(dateFrom.setHours(0, 0, 0, 0)) : '',
            dateTo ? new Date(dateTo.setHours(23, 59, 59, 999)) : '',
            category,
            paymentMethod
        ])
    }

    const handleReset = () => {
        onFilter(['', '', '', ''])
        setDateFrom('')
        setDateTo('')
        setCategory('')
        setPaymentMethod('')
        queryClient.invalidateQueries(['expenses','paginated'])
    }

    return (
        <>
            <span className='cursor-pointer' onClick={() => setIsShow(!isShow)}><i className="fa-solid fa-list-check"></i> {isShow ? 'Hide' : 'Show'} Filter</span>
            <Collapse in={isShow}>
                <Form onSubmit={handleFilter}>
                    <Card className='mt-2'>
                        <Card.Body>
                            <Row>
                                <Col lg="3" className='mb-2'>
                                    <DatePicker className='form-control' label='Date From'
                                        selected={dateFrom} onChange={setDateFrom} maxDate={dateTo || undefined} dateFormat="dd.MM.yyyy"
                                    />
                                </Col>
                                <Col lg="3" className='mb-2'>
                                    <DatePicker className='form-control' label='Date To'
                                        selected={dateTo} onChange={setDateTo} minDate={dateFrom || undefined} dateFormat="dd.MM.yyyy"
                                    />
                                </Col>
                                <Col lg="3" className='mb-2'>
                                    <FormInput value={category} label="Category" size="md" onChange={(e) => setCategory(e.target.value)} />
                                </Col>
                                <Col lg="3" className='mb-2'>
                                    <FormInput value={paymentMethod} label="Payment Method" size="md" onChange={(e) => setPaymentMethod(e.target.value)} />
                                </Col>
                            </Row>
                            <div className='mt-3 d-flex justify-content-end'>
                                <Button variant="outline-secondary" className='me-2' onClick={handleReset}>Reset</Button>
                                <Button type='submit' disabled={isFiltering} >{isFiltering ? 'Filtering...' : "Filter"}</Button>
                            </div>
                        </Card.Body>
                    </Card>

                </Form>
            </Collapse>
        </>

    )
}

export default ExpensesFilter